// Display a full page error with an illustration, a title and an optional message
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import { Header } from '../layouts';
import errorImage from '../../assets/error.svg';
import { formatApiError } from '../../common/apiError';

const ErrorPage = ({ image, imageWidth, title, children }) => (
  <Container>
    <Header hideButton />
    <Box
      sx={{
        padding: ['10vh 3vh', '10vh', '10vh 20vh'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img
        src={image}
        alt=""
        style={{ width: imageWidth, maxWidth: '100%', height: 'auto' }}
      />
      <Box sx={{ marginTop: '10%' }}>
        <Typography variant="h1" component="h1" sx={{ textAlign: 'center' }}>
          {title}
        </Typography>
        {children && (
          <Typography
            component="p"
            sx={{ textAlign: 'center', marginTop: 2, wordBreak: 'break-word' }}
          >
            {children}
          </Typography>
        )}
      </Box>
    </Box>
  </Container>
);

ErrorPage.propTypes = {
  image: PropTypes.string,
  imageWidth: PropTypes.string,
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

ErrorPage.defaultProps = {
  image: errorImage,
  imageWidth: '50%',
  children: null,
};

/**
 * Display the real status and message of an RTK Query error
 */
export const ApiErrorPage = ({ error }) => {
  const { status, title, message } = formatApiError(error);
  return (
    <ErrorPage imageWidth="200px" title={`Erreur ${status} : ${title}`}>
      {message}
    </ErrorPage>
  );
};

ApiErrorPage.propTypes = {
  error: PropTypes.shape({}).isRequired,
};

export default ErrorPage;
